export enum EItemTransferTickResult {
  ITTR_DONE,
  ITTR_PARTIAL,
  ITTR_FAILED,
}
